import { useEffect, useState } from 'react';
import { doc, onSnapshot } from 'firebase/firestore';
import { db } from '../firebase';
import { useAuth } from '../contexts/AuthContext';

export default function useUserSubscription() {
  const { user } = useAuth();
  const [subscription, setSubscription] = useState(null);

  useEffect(() => {
    if (!user) return;
    const ref = doc(db, 'users', user.uid);
    const unsub = onSnapshot(ref, (snap) => {
      setSubscription(snap.data()?.subscription || null);
    });
    return unsub;
  }, [user]);

  // Compute effective access: ACTIVE or CANCELLED but before nextBillingTime
  const status = subscription?.status;
  const nextBillingTime = subscription?.nextBillingTime;
  const nextMs = nextBillingTime ? new Date(nextBillingTime).getTime() : null;
  const nowMs = Date.now();
  const withinGrace = status === 'CANCELLED' && nextMs && nowMs < nextMs;
  const isPremium = status === 'ACTIVE' || withinGrace;

  return { subscription, isPremium, premiumEndsAt: nextBillingTime };
}


